<template>
        <router-view></router-view>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  data: function () {
    return {
  
    };
  },
  methods: {
  
  },

  name: "viewAccountIndex",
  components: {

  },
});
</script>

<style lang="scss" scoped>
// @import "@/assets/scss/global.scss";
// @import "@/assets/scss/abstracts/_variables.scss";

// .vr {
//   width: 2px !important;
//   background: transparent;
//   border-left: 1px solid #585858;
// }

// @media only screen and (min-width: 1025px) {
//   .mobile-navigation {
//     display: none;
//   }
//   #v-pills-tab {
//     .active {
//       width: 100% !important;
//     }
//   }
//   .desktop {
//     display: block;
//   }
// }
// @media #{$media-desktop} {
//   .mobile-navigation {
//     display: block;
//     background: $color-card;
//     #v-pills-tab {
//       display: grid;
//       grid-template-columns: repeat(3, 1fr);
//       overflow: auto;
//       flex-wrap: nowrap;
//       .active {
//         border-bottom: 4px solid $color-blue;
//         border-left: none !important;
//       }
//     }
//   }
//   .section-profile .vr {
//     display: none;
//   }
//   .desktop {
//     display: none !important;
//   }
// }
</style>
